import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Product } from '@app/core/interfaces';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TextareaModule } from 'primeng/textarea';
import { ProductLineEmitter } from '../product-detail-infos-input/product-detail-infos-input';
import { Nl2brPipe } from '@app/core/pipes';
import { ProductService } from '@app/core/services';

@Component({
  selector: 'app-product-detail-infos-textarea',
  imports: [
    CommonModule,
    FormsModule,
    TextareaModule,
    ButtonModule,
    ButtonGroupModule,
    AutoFocusModule,
    Nl2brPipe,
  ],
  templateUrl: './product-detail-infos-textarea.html'
})
export class ProductDetailInfosTextarea {
  @Input() product!: Product;
  @Input() label!: string;
  @Input() property!: string;

  @Output() productChange = new EventEmitter<Product>(); // For two way binding of [(product)]
  @Output() isSendingData = new EventEmitter<ProductLineEmitter>();

  isEditMode: boolean = false;

  isSendingInputData: boolean = false;

  value: any = null;
  defaultValue: any = this.value;
  
  constructor(
    private productService: ProductService
  ) { }

  ngOnInit(): void {
    this.value = this.property in this.product ? this.product[this.property] : '';
    this.defaultValue = this.property in this.product ? this.product[this.property] : '';
  }

  onToggleMode() {
    this.isEditMode = !this.isEditMode;
  }

  onInputClose() {
    this.value = this.defaultValue;
    this.onToggleMode();
  }

  onSaveComment() {
    this.onToggleMode();

    if (this.defaultValue !== this.value) {
      this.isSendingInputData = true;
      this.isSendingData.emit({ property: this.property, isSendingData: true });
  
      const data: any = {};
      data[this.property] = this.value;
  
      this.productService
        .patch(this.product.id, data)
        .subscribe({
          next: (p: Product) => {
            this.product = {...this.product, ...data};
            this.defaultValue = this.value;
          },
          complete: () => {
            this.isSendingInputData = false;
            this.productChange.emit(this.product);
            this.isSendingData.emit({ property: this.property, isSendingData: false, message: { severity: 'info', summary: 'Modification', detail: `${this.label} a été changé avec succès` } });
          }
        })
    }
  }
}
